import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const ourFamilyPages: ResourceProps = {
  name: Resource.OUR_FAMILY,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Our Family",
  },
};

export default ourFamilyPages;
